import { ChangeDetectionStrategy, Component, booleanAttribute, computed, input } from '@angular/core';

export interface EventqSiteOverviewField {
  id: string;
  label: string;
  value: string;
}

@Component({
  selector: 'eventq-site-overview-details',
  templateUrl: './site-overview-details.html',
  styleUrl: './site-overview-details.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.aria-busy]': 'loading() ? "true" : null',
  },
})
export class EventqSiteOverviewDetails {
  readonly sectionHeading = input.required<string>();
  readonly generalLabel = input.required<string>();
  readonly siteName = input.required<string>();
  readonly address = input.required<string>();
  readonly fields = input.required<readonly EventqSiteOverviewField[]>();
  readonly loading = input(false, { transform: booleanAttribute });

  readonly hasContent = computed(
    () =>
      this.fields().length > 0 ||
      this.siteName().trim().length > 0 ||
      this.address().trim().length > 0,
  );
}
